import React from 'react';
import PropTypes from 'prop-types';
import ReactLink from '@client/components/reactLink/ReactLink';
import { trackCustomEvent } from '@client/tracking/GTM';
import {
  EVENT_GA,
  CATEGORY_NAVIGATION,
  ACTION_LINK_CLICK,
} from '@client/definitions/tracking';
import styles from './navigationItem.scss';

export const NavigationItem = ({ name, path }) => {
  const trackNavigationClick = () => {
    trackCustomEvent(EVENT_GA, {
      click_category: CATEGORY_NAVIGATION,
      click_type: ACTION_LINK_CLICK,
      click_text: name,
    });
  };

  return (
    <li className={styles?.navItem}>
      <ReactLink
        className={styles?.link}
        to={path}
        onClick={trackNavigationClick}
      >
        {name}
      </ReactLink>
    </li>
  );
};

NavigationItem.propTypes = {
  name: PropTypes.string,
  path: PropTypes.string,
};
